module.exports = __webpack_public_path__ + "img/logo@2x.3ac3d5c0.png";